import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import parse from 'html-react-parser'
import {useEffect, useState} from "react";
import CodeEditor from '@uiw/react-textarea-code-editor';

const RulesDialog = (props) => {
	const [isEdit, setIsEdit] = useState(false)
	const [league, setLeague] = useState(props?.selectedLeague)

	useEffect(()=> {
		setLeague(props?.selectedLeague)
	}, [props?.selectedLeague])
	return (
		<Dialog
		open={props.isShowRuleModal}
		onClose={() => props.setIsShowRuleModal(false)}
		aria-labelledby="alert-dialog-title"
		aria-describedby="alert-dialog-description"
		maxWidth="md"
	>
		<DialogTitle id="alert-dialog-title">
			Rules
		</DialogTitle>
		<DialogContent
		>
			<DialogContentText id="alert-dialog-description" >
				<Box sx={{minWidth: '700px', minHeight: '500px', color: 'black !important'}}
				>
				{
					isEdit || !props?.selectedLeague?.rules ? (
						<><CodeEditor

							data-color-mode="light"
						value={props?.selectedLeague?.rules && props?.selectedLeague?.rules}
						language="html"
						placeholder="Please enter JS code."
						onChange={(evn) => setLeague({...league, rules: evn.target.value})}
						padding={15}
						style={{
							overflowY:'scroll',
							fontSize: 12,
							width: 800,
							height: 500,
							backgroundColor: "#f5f5f5",
							fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
						}}
					/></>
					) : (
						<>{props?.selectedLeague?.rules && parse(props?.selectedLeague?.rules)}</>
					)
				}
				</Box>
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			{isEdit || !props?.selectedLeague?.rules ?
				<Button
					disabled={league?.rules ? false: true}
					onClick={() => {
					props.onSuccessHandler(league);
					setIsEdit(false);
				}}>
					Save
				</Button>
				:<Button onClick={() => setIsEdit(true)}>Edit</Button>
			}
			<Button onClick={() => {
				props.setIsShowRuleModal(false);
				setIsEdit(false);
			}}>Cancel</Button>
		</DialogActions>
	</Dialog>)
}
export default RulesDialog;
